import { getGlobalEventsLogs } from '@cian/events-log';

import { type TJsonQuery } from '@/packages/JsonQuery';

import { FILTERS_TOPIC } from '@/microfrontends/filters/shared/eventsLog/topics';

import { type ILocation } from '../../types/location';
import { type ISearchMeta } from '../../types/searchMeta';

interface IUpdateFiltersPayload {
  jsonQuery: TJsonQuery;
  locations: ILocation[];
  meta: ISearchMeta;
}

export function fireUpdateFiltersEvent(payload: IUpdateFiltersPayload): void {
  const globalLog = getGlobalEventsLogs();

  globalLog.produce(FILTERS_TOPIC, {
    type: 'FILTERS_UPDATED',
    value: payload as never,
  });
}
